import { render, staticRenderFns } from "./newsdetails.vue?vue&type=template&id=fc7d9768&scoped=true"
import script from "./newsdetails.vue?vue&type=script&lang=js"
export * from "./newsdetails.vue?vue&type=script&lang=js"
import style0 from "./newsdetails.vue?vue&type=style&index=0&id=fc7d9768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7d9768",
  null
  
)

export default component.exports